var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormkitArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0009 40.4444C13.1298 40.4444 12.4453 39.7599 12.4453 38.8888V10.8888C12.4453 10.0177 13.1298 9.33325 14.0009 9.33325C14.872 9.33325 15.5564 10.0177 15.5564 10.8888V38.8888C15.5564 39.7599 14.872 40.4444 14.0009 40.4444Z",
    fill: "#100C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 43.5563C13.7951 43.5587 13.5928 43.5185 13.4053 43.4381C13.2178 43.3578 13.0491 43.239 12.9102 43.0896L2.02135 32.2007C1.39913 31.5785 1.39913 30.614 2.02135 29.9918C2.64358 29.3696 3.60802 29.3696 4.23024 29.9918L14.0302 39.7918L23.8302 29.9918C24.4525 29.3696 25.4169 29.3696 26.0391 29.9918C26.6614 30.614 26.6614 31.5785 26.0391 32.2007L15.1502 43.0896C14.8391 43.4007 14.4347 43.5563 14.0614 43.5563H13.9991Z",
    fill: "#100C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormkitArrowdown);
export default __webpack_public_path__ + "static/media/formkit_arrowdown.73d07e329340c1b9910f8b0212f6519c.svg";
export { ForwardRef as ReactComponent };